import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ScrollAnimation = ({ children, animateIn, delay = 0 }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: false, // Allow re-triggering of the animation
    initialInView: false
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden"); // Optionally reset to 'hidden' when out of view
    }
  }, [controls, inView]);

    const animationVariants = {
        visible: {
            opacity: 1,
            x: animateIn === 'fadeInRight' ? [20, 0] : animateIn === 'fadeInLeft' ? [-20, 0] : 0,
            y: animateIn === 'fadeInUp' ? [20, 0] : animateIn === 'fadeInDown' ? [-20, 0] : 0,
            scale: animateIn === 'flipInX' ? [0.8, 1.0] : 1,
            rotateX: animateIn === 'flipInX' ? [90, 0] : 0,
            transition: { delay, duration: 0.5 }
        },
        hidden: {
            opacity: 0,
            x: animateIn === 'fadeInRight' ? 20 : animateIn === 'fadeInLeft' ? -20 : 0,
            y: animateIn === 'fadeInUp' ? 20 : animateIn === 'fadeInDown' ? -20 : 0,
            scale: animateIn === 'flipInX' ? 0.8 : 1,
            rotateX: animateIn === 'flipInX' ? 90 : 0,
        },
    };

    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={animationVariants}
        >
            {children}
        </motion.div>
    );
};

export default ScrollAnimation;